gsap.registerPlugin(ScrollTrigger, SplitText, DrawSVGPlugin);

document.addEventListener("DOMContentLoaded", () => {
    // Home Page Banner Text Animation
    if (document.querySelector('.slider-animation')) {
        const split = new SplitText(".slider-animation", {
            type: "lines",
            linesClass: "lines"
        })
        gsap.to(".slider-animation", {
            autoAlpha: 1
        })
        split.lines.forEach((line, index) => {
            let chars = new SplitText(line, {
                type: "lines"
            })
            gsap.from(chars.lines, {
                yPercent: 120,
                stagger: 1,
                duration: 1,
                ease: "power4.out",
                delay: 0.5 * index
            }, "0.8")
        });
    }

    // Draw SVG Animation
    if (document.querySelector('.drawsvg-section')) {
        const drawsvgSections = document.querySelectorAll('.drawsvg-section');
        drawsvgSections.forEach((section) => {
            const drawSvg = gsap.timeline();
            drawSvg.from(section.querySelectorAll(".drawsvg path"), {
                drawSVG: 0,
                duration: 5
            });
            ScrollTrigger.create({
                trigger: section,
                animation: drawSvg,
                start: "top 75%",
                end: "50% 30%",
                toggleActions: "play none none reverse"
            });
        });
    }

    // Collection Banner Animation
    if (document.querySelector('.collection-hero__banner')) {
        gsap.timeline().to('.collection-banner__caption .h5', {
                opacity: 1,
                x: 0,
                duration: .5,
                ease: 'back.inOut'
            })
            .to('.collection-banner__caption .h1', {
                opacity: 1,
                x: 0,
                duration: .5,
                ease: 'back.inOut'
            });
    }

    // Home Page Loader Ball Animation
    if (document.querySelector('.product-feature-section')) {
        let section = document.querySelector(".product-feature-section");
        let content3 = document.querySelector(".content-3").offsetHeight;
        let content4 = document.querySelector(".content-4").offsetHeight;
        let contentHeight = content4 - content3;

        const sectionHeight = section.offsetHeight;
        const viewportHeight = window.innerHeight;

        // const topbarHeight = document.querySelector('.topbar').offsetHeight;
        // const headerHeight = document.querySelector('.site-header').offsetHeight;

        let setValue = (sectionHeight > viewportHeight) ? sectionHeight : viewportHeight;
        let finalSetValue = (setValue / 2) + 100
        function removeClass() {
            document.querySelector(".product-feature-section .h2").classList.remove("add-webstroke");
        }
        function addClass() {
            document.querySelector(".product-feature-section .h2").classList.add("add-webstroke");
        }

        let drawLine = gsap.timeline();

        ScrollTrigger.create({
            trigger: ".pin__section",
            animation: drawLine,
            start: "top 90%",
            end: "bottom center",
            scrub: 1,
        })
        drawLine.fromTo("#line", {
            drawSVG: "0"
        }, {
            duration: 1,
            drawSVG: "100%"
        });



        let anim01 = gsap.timeline()

            .fromTo(".loader-ball:not(.design_mode) img", {
                y: finalSetValue,
                duration: 1
            }, {
                y: 0,
                duration: 1,
                ease: "sine.out"
            })
            .fromTo(".loader-ball:not(.design_mode) img", {
                scale: 1,
                y: 0,
                duration: 1
            }, {
                scale: 2,
                x: (window.innerWidth / 2) + 500,
                y: (window.innerHeight / 2) + 300,
                duration: 1,
                ease: "sine.out",
                onReverseComplete: addClass
            }, 1.1)
            .fromTo('.content-section .content-1', {
                opacity: 0,
                yPercent: 150
            }, {
                onStart: removeClass,
                duration: 0.5,
                ease: "power2.inOut",
                opacity: 1,
                yPercent: 0
            }, 1.6)
            .fromTo('.content-section .content-2', {
                opacity: 1,
                yPercent: 200
            }, {
                duration: 1,
                ease: "power2.inOut",
                opacity: 1,
                yPercent: 0
            }, 1.7)
            .fromTo('.content-section .content-3', {
                opacity: 1,
                yPercent: 300
            }, {
                duration: 1,
                ease: "power2.inOut",
                opacity: 1,
                yPercent: 0
            }, 1.7)

        anim01.timeScale(1)

        ScrollTrigger.create({
            trigger: ".pin__section",
            animation: anim01,
            start: "top top",
            end: "+=2100",
            scrub: 0,
            pinSpacing: true,
            pin: true,
            // markers: {fontSize: "18px", indent: 0}
        });

        let anim02 = gsap.timeline()

            .fromTo('.content-section .content-4', {
                opacity: 1,
                y: 0
            }, {
                duration: 1,
                opacity: 1,
                y: (contentHeight)
            }, ">")

        ScrollTrigger.create({
            trigger: ".product-feature-section + .shopify-section",
            animation: anim02,
            start: "top " + sectionHeight,
            end: "+=600 " + sectionHeight,
            scrub: 0,
            pinSpacing: false,
            // markers: {fontSize: "18px", indent: 0}
        });
    }


    // Image Banner With Text Animation
    if (document.querySelector('.global-image-banner')) {
        let mm = gsap.matchMedia();
        const banner = document.querySelector('.global-image-banner');
        const newBannerHeight = banner.offsetHeight;
        const bannerSectionWidth = window.innerWidth;
        const bannerSectionHeight = window.innerHeight;

        // Initial gsap animation if window width is >= 1200
        if (window.innerWidth >= 1200) {
            gsap.to(banner, {
                height: bannerSectionHeight,
                maxWidth: bannerSectionWidth
            });
        }
        // ScrollTrigger based animation
        mm.add("(min-width: 1200px)", () => {
            const trigger = ScrollTrigger.create({
                trigger: banner,
                start: `top 35%`,
                end: `top+=${newBannerHeight} 30%`,
                onEnter: () => {
                    banner.classList.add('activate-banner-animation');
                    gsap.to(banner, {
                        maxWidth: '1340px',
                        height: newBannerHeight,
                        borderRadius: "50px",
                        duration: 1,
                        ease: 'Back.easeInOut',
                        // onComplete: () => {
                        //     // Refresh the ScrollTrigger
                        //     ScrollTrigger.refresh();
                        // }
                    });
                }
            });
            // Ensure ScrollTrigger is refreshed on window resize
            // window.addEventListener('resize', () => {
            //     console.log("Window resized, refreshing ScrollTrigger");
            //     trigger.refresh();
            // });
        });
    }

    // Slider Effect animation for Images
    if (document.querySelector('.slideffect-section')) {
        const imageSlideEffect = document.querySelectorAll('.slideffect-section');
        imageSlideEffect.forEach((section) => {
            const imageslideffect = section.querySelectorAll(".slide-effect:not(.design_mode) .slide-effect-overlay");
            const imageslideffect2 = section.querySelectorAll(".slide-effect:not(.design_mode) img");
            ScrollTrigger.create({
                animation: gsap.timeline()
                    .fromTo(imageslideffect, {
                        y: "0%"
                    }, {
                        y: "-100%",
                        duration: 1,
                        ease: "none"
                    })
                    .fromTo(imageslideffect2, {
                        scale: 2
                    }, {
                        scale: 1,
                        duration: 1,
                        ease: "none"
                    }, -0.1),
                trigger: section,
                start: "top 95%",
                end: "40% 50%",
                toggleActions: "play none none reverse",
                scrub: 1.5
            });
        });
    }
});